import { Injectable } from "@angular/core";
import { GenericBaseService } from "./generic-base.service";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { DocumentIntelligenceModel } from "../models/document-intelligence-model.model";
import { ApiVersion, UrlService } from "./url.service";

@Injectable({
    providedIn: 'root'
})

export class DocumentIntelligenceService extends GenericBaseService {
    constructor(
        protected httpClient: HttpClient,
        protected toastrService: ToastrService,
        protected translateService: TranslateService,
        protected url: UrlService
    ) {
        super('Document Intelligence', httpClient, toastrService, url, ApiVersion.v2);
    }

    getProviders(afterGetCallback?: Function, customMessage?: string): void {
        this.getNow<string[]>(
            '/document-intelligence/providers',
            undefined,
            afterGetCallback,
            customMessage
        );
    }

    getFormatConverters(provider: string, afterGetCallback?: Function, customMessage?: string): void {
        this.getNow<string[]>(
            `/document-intelligence/format-converters?provider=${provider}`,
            undefined,
            afterGetCallback,
            customMessage
        );
    }

    createModel(model: DocumentIntelligenceModel, afterPostCallback?: Function, customMessage?: string): void {
        this.postNow(
            '/document-intelligence/models',
            model,
            afterPostCallback,
            customMessage
        );
    }

    updateModel(id: string, model: DocumentIntelligenceModel, afterPutCallback?: Function, customMessage?: string): void {
        this.putNow(
            `/document-intelligence/models/${id}`,
            model,
            afterPutCallback,
            customMessage
        );
    }

    deleteModel(id: string, afterDeleteCallback?: Function, customMessage?: string): void {
        this.deleteNow(
            `/document-intelligence/models/${id}`,
            afterDeleteCallback,
            customMessage
        )
    }
}